import { queryOptions, type UseQueryOptions } from '@tanstack/react-query';
import type {
  GetUserSettingsData,
  GetUserSettingsResponse,
} from 'generated/openapi';

import { PrivateApi } from '@/shared/api/httpClient';

export const getUserSettingsKey = () => ['settings'] as const;

const getUserSettingsUrl: GetUserSettingsData['url'] = 'settings';

export const getUserSettingsOptions = <T = GetUserSettingsResponse>(
  options?: Omit<
    UseQueryOptions<GetUserSettingsResponse, unknown, T>,
    'queryKey' | 'queryFn'
  >,
) =>
  queryOptions<GetUserSettingsResponse, unknown, T>({
    queryKey: getUserSettingsKey(),
    queryFn: () =>
      PrivateApi.get(getUserSettingsUrl).json<GetUserSettingsResponse>(),
    ...options,
  });
